import { render } from "./PlatformManagement.vue?vue&type=template&id=ff0a48ea&scoped=true"
import script from "./PlatformManagement.vue?vue&type=script&lang=js"
export * from "./PlatformManagement.vue?vue&type=script&lang=js"

import "./PlatformManagement.vue?vue&type=style&index=0&id=ff0a48ea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0a48ea"]])

export default __exports__